import React from 'react';
import { useReveal } from '../hooks/useReveal';
import HeroContent from './hero/HeroContent';
import HeroVisual from './hero/HeroVisual';

export default function Hero() {
  const { ref: leftRef, inView: leftIn } = useReveal();
  const { ref: rightRef, inView: rightIn } = useReveal();

  return (
    <section id="home" className="hero-bg relative overflow-hidden">
      <div className="pointer-events-none absolute -top-24 -left-24 w-80 h-80 rounded-full bg-blue-100/70 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-indigo-100/60 blur-3xl" />

      <div className="container-x relative grid lg:grid-cols-2 gap-10 lg:gap-14 items-center py-14 md:py-20">
        <div ref={leftRef} className={`reveal ${leftIn ? 'in-view' : ''}`}>
          <HeroContent />
        </div>
        <div ref={rightRef} className={`reveal ${rightIn ? 'in-view' : ''}`}>
          <HeroVisual />
        </div>
      </div>
    </section>
  );
}
